import { randomBytes, createHash } from 'crypto'

const CODE_VERIFIER_LENGTH = 64

/**
 * Generates a cryptographically random PKCE code_verifier (RFC 7636 Section 4.1).
 * Returns a 64-character base64url string (within the required 43-128 range).
 */
export function generateCodeVerifier(): string {
  return randomBytes(CODE_VERIFIER_LENGTH).toString('base64url')
}

/**
 * Derives a PKCE code_challenge from a code_verifier using S256 (RFC 7636 Section 4.2).
 * Returns base64url(SHA256(code_verifier)) without padding.
 */
export function generateCodeChallenge(codeVerifier: string): string {
  return createHash('sha256').update(codeVerifier).digest('base64url')
}
